import { api } from 'api'

type ISOString = string

type SendTipRequest = {
  companyId: number
  tips: {
    workId: number
    amount: number
  }[]
}

type SendTipResponse = {
  tipTakeRate: number
  totalPaymentAmount: number
  totalChargeAmount: number
  workHistory: {
    work: {
      workId: number
      startedAt: ISOString
      completedAt: ISOString
      worker: {
        workerId: number
        name: string
        profilePicUrl?: string
      }
      shift: {
        shiftId: number
        startsAt: ISOString
        endsAt: ISOString
        location?: {
          locationId: number
          name: string
          timezone: string
        }
        position: {
          positionId: number
          name: string
        }
      }
    }
    chargeHistory: {
      chargeItemId: number
      amount: number
      createdAt: ISOString
    }[]
    paymentHistory: (
      | {
          userPaymentId: number
          amount: number
          createdAt: ISOString
        }
      | {
          amount: number
          error: string
        }
    )[]
    totalPaymentAmount: number
    totalChargeAmount: number
  }[]
}

export async function sendTips({ companyId, tips }: SendTipRequest) {
  if (tips?.length === 0) {
    throw new Error('No tips to send')
  }

  const response = await api.post<SendTipResponse>(
    `/company/${companyId}/tip`,
    {
      tips,
    }
  )

  return {
    ...response.data,
    workHistory: response.data.workHistory.map((work) => {
      const error = work.paymentHistory.find(
        (payment): payment is { amount: number; error: string } =>
          'error' in payment
      )
      const paymentHistory = work.paymentHistory.filter(
        (
          payment
        ): payment is {
          userPaymentId: number
          amount: number
          createdAt: ISOString
        } => 'userPaymentId' in payment
      )
      return {
        ...work,
        error,
        paymentHistory,
      }
    }),
  }
}
